module fdm.flightEvents {

    angular.module('fdm.flightEvents')
        .config(['$stateProvider', '$locationProvider',
            ($stateProvider: ng.ui.IStateProvider,
                $locationProvider: ng.ILocationProvider) => {

                dg.uiRouter.StateProviderBuilderService.configure($stateProvider)
                    .dashboardState('overview', 'operations-safety-overview',
                        //'/flight-event/flight-event-dashboard/', {
                        '{parentId}/flight-event/operations-safety-overview', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                                    templateUrl: '/app/src/flight-events/op-safety-overview.html'
                                }),
                            ],
                            childDisplayers: {
                                KPIS: <dg.actions.ICompositeDisplayerOptions>{
                                    templateUrl: '/digmo/src/actions/kpi/kpi-view.html',
                                    displayValue: 'Kpi',
                                    type: 'kpi'
                                }
                            }
                        }
                    })
                    .dashboardState('yearToDate', 'ytd-op-trends',
                        //'/flight-event/flight-event-dashboard/', {
                        '{parentId}/flight-event/ytd-operation-trends', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                                    templateUrl: '/app/src/flight-events/ytd-op-trends.html'
                                }),
                            ],

                            //childDisplayers: {
                            //    KPIS: <dg.actions.ICompositeDisplayerOptions>{
                            //        templateUrl: '/digmo/src/actions/kpi/kpi-view.html',
                            //        displayValue: 'Kpi',
                            //        type: 'kpi'
                            //    }
                            //}
                        }
                    })
                    //.dashboardState('flightDashboard', 'flight-dashboard',
                    //'{parentId}/flight-event/flight-dashboard', {
                    //    options: () => <dg.actions.IQueryInvokerOptions>{
                    //        compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                    //            <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                    //                templateUrl: 'app/src/dashboard/flight-dashboard.html'
                    //            })
                    //        ]
                    //    }
                    //})


                    .detailsState('flightEventDetails', 'flight-events',
                        '{parentId}/flight-event/{aggregateId}/details', {
                        templateUrl: () => '/app/src/flight-events/flight-event-details.html',
                        options: () => <dg.actions.IQueryResultDisplayerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                                    actionColumnEnabled: false,
                                    //uiGrid: {
                                    //    columnDefs: [{
                                    //        field: 'level',
                                    //        cellTemplate: '/app/src/flight-legs/flight-leg-level-grid-template-cell.html'
                                    //    }]
                                    //}
                                })
                            ]
                        }
                    })
                    .listState('flightEvents', 'flight-events',
                        '{parentId}/flight-event/list', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                                    uiGrid: {
                                        columnDefs: [
                                            {
                                                field: 'status',
                                                displayName: '',
                                                width: 55
                                            },
                                            { field: 'aggregate', width: '100' },
                                            { field: 'description', width: '20%' },
                                            { field: 'parameter', minWidth: 80 },
                                            { field: 'threshold', visible: false },
                                            { field: 'value', minWidth: 60 },
                                            { field: 'exceedance', minWidth: 60 },
                                            { field: 'unit', minWidth: 50 },
                                            { field: 'level', minWidth: 53 },
                                            { field: 'phase', minWidth: 55 },
                                            { field: 'time', minWidth: 60 },
                                            { field: 'duration', minWidth: 72 },
                                            { field: 'aircraft', minWidth: 70 },
                                            { field: 'legDate', minWidth: 110 },
                                            { field: 'leg', minWidth: 85 },
                                            { field: 'airport', visible: false }, //{ field: 'airport', minWidth: 70 },
                                            { field: 'acceptedOrRejectedComment', visible: false },
                                            { field: 'smsIntegrationMessage', visible: false }
                                        ]
                                    }
                                })
                            ]
                        }
                    })
                    .listState('analysedEvents', 'analysed-events',
                        '{parentId}/flight-event/analysed-events', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                                    actionColumnEnabled: false,
                                    uiGrid: {
                                        columnDefs: [
                                            { field: 'aircraft', width: 80 },
                                            { field: 'leg', width: 85 },
                                            { field: 'legDate', minWidth: 115 },
                                            { field: 'departure', minWidth: 60 },
                                            { field: 'arrival', minWidth: 60 },

                                            { field: 'phase', minWidth: 60 },
                                            { field: 'aggregate', minWidth: 80 },
                                            { field: 'description', width: '20%' },
                                            { field: 'parameter', minWidth: 80 },
                                            { field: 'threshold', visible: false },
                                            { field: 'value', minWidth: 60 },
                                            { field: 'exceedance', minWidth: 60 },
                                            { field: 'unit', minWidth: 50 },
                                            { field: 'level', minWidth: 55 },

                                            //{ field: 'pilotFlying', minWidth: 60 },

                                            { field: 'airport', minWidth: 60 },
                                            { field: 'family', visible: false },

                                            { field: 'status', width: 50, displayName: '' },
                                            { field: 'acceptedOrRejectedComment', visible: false },
                                            { field: 'smsIntegrationMessage', visible: false },
                                            { field: 'precursor', visible: false}
                                        ]
                                    }
                                })
                            ]
                        }
                    })
                    .listState('topEvents', 'reports/top-cirtical-events-details',
                        '{parentId}/flight-event/top-events', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                                    templateUrl: '/app/src/flight-events/top-critical-events-details.html'
                                }),
                                <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                                    //actionColumnEnabled: false,
                                    uiGrid: {
                                        columnDefs: [
                                            { field: 'aggregate', width: '30%' },
                                            //{ field: 'level', cellTemplate: '/app/src/flight-legs/flight-leg-level-grid-template-cell.html' },
                                        ]
                                    }
                                })
                            ]
                        }
                    })
                    .listState('flightPhaseEvents', 'reports/flight-events-per-flight-phase-details',
                        '{parentId}/flight-event/flight-phase-events', {
                        options: () => <dg.actions.IQueryInvokerOptions>{
                            compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                                <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                                    templateUrl: '/app/src/flight-events/flight-events-per-flight-phase-details.html'
                                }),
                                <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                                    type: 'grid',
                                })
                            ]
                        }
                    })
                    .widgetState('flightEventTrace',
                        '{parentId}/flight-event/{aggregateId}/details/flight-trace',
                        'flight-legs/flight-trace-modal',
                        {
                            widgetTitle: () => 'Event Trace',
                            widgetTemplateUrl: () => '/app/src/flight-legs/flight-trace.html',
                            includeInFilter: () => ['parameters']
                        },
                        {
                            windowClass: 'extra-wide-modal'
                        });

                //$stateProvider
                //    .state<dg.actions.IListQueryStateResolve>('app.flightEvents', {
                //        url: 'flight-events?aircraft.id',
                //        templateUrl: '/digmo/src/actions/list-query/default-list-query-view.html',
                //        apiUrl: "/{ownerId}/flight-event/flight-events",
                //        resolve: {
                //            query: (actionService: dg.actions.ActionService, $transition$: any) => {
                //                return actionService.getAction('/flight-event/flight-events', $transition$.params());
                //            },
                //            options: () => {
                //                return {
                //                    listOptions: dg.lists.listOptionsServiceProvider.getGridOptions({
                //                        actionColumnEnabled: false,
                //                        uiGrid: {
                //                            columnDefs: [
                //                                { field: 'aggregate', width: '30%' },

                //                                { field: 'level', cellTemplate: '/src/flight-legs/flight-leg-level-grid-template-cell.html' },
                //                                //{ field: 'event', width: 80 },
                //                                //{ field: 'phase', width: 80 },
                //                                //{ field: 'aircraft', width: 80 },
                //                                //{ field: 'aircraftType', width: 100 },
                //                                //{ field: 'legDate', width: 100 },
                //                                //{ field: 'leg', width: 100 },
                //                                //{ field: 'arrival', width: 80 },
                //                                //{ field: 'departure', width: 100 }
                //                            ]
                //                        }
                //                    })
                //                };
                //            }
                //        }
                //    })
                //    .state('app.flightEventsDetails', {
                //        url: 'flight-events/:aggregateId/details',
                //        templateUrl: '/digmo/src/actions/query-result/default-query-result-view.html',
                //        apiUrl: '/{ownerId}/flight-event/{aggregateId}/flight-event-details',
                //        resolve: {
                //            templateUrl: () => '/src/flight-events/flight-event-details.html',
                //            queryResult: (actionService: dg.actions.ActionService, $transition$: any) => {
                //                return actionService.getModelQueryResult('/flight-event/' + $transition$.params().aggregateId + '/flight-event-details/result');
                //            },
                //            options: () => {
                //                return {

                //                    listOptions: dg.lists.listOptionsServiceProvider.getGridOptions({
                //                        actionColumnEnabled: false,
                //                        uiGrid: {
                //                            columnDefs: [{
                //                                field: 'level',
                //                                cellTemplate: '/src/flight-legs/flight-leg-level-grid-template-cell.html'
                //                            }]
                //                        }
                //                    })
                //                };
                //            }
                //        }
                //    })


                //.state('app.projectDefinition', {
                //    url: 'projects/definition',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-model.html',
                //    controller: 'DynamicActionController',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/project/define-project'
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.project', {
                //    abstract: true,
                //    url: 'projects/:aggregateId',
                //    templateUrl: '/src/projects/project.html',
                //    controller: 'ProjectGeneralController'
                //})
                //.state('app.project.overview', {
                //    url: '/overview',
                //    templateUrl: '/src/projects/project-overview.html',
                //    controller: 'ProjectOverviewController',
                //    data: {
                //        apiUrl: null
                //    }
                //})
                //.state('app.project.details', {
                //    url: '/details',
                //    templateUrl: '/src/projects/project-details.html',
                //    controller: 'ProjectDetailsController',
                //    data: {
                //        apiUrl: '/{ownerId}/project/{aggregateId}/update-project'
                //    }
                //})
                //.state('app.project.operation', {
                //    url: '/operation',
                //    templateUrl: '/src/projects/project-operation.html',
                //    controller: 'ProjectOperationController',
                //    data: {
                //        apiUrl: null
                //    }
                //})
                //.state('app.project.operation.operationalFiles', {
                //    url: '/files/:parentId',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list-sm.html',
                //    controller: 'DynamicActionController',
                //    data: {
                //        apiUrl: '/{ownerId}/{parentId}/file-descriptor/operational-files',
                //    },
                //    resolve: {
                //        data: ['$stateParams', ($stateParams: dgUtils.IDgStateParamsService): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/' + $stateParams.parentId + '/file-descriptor/operational-files'
                //                },
                //                listInit: {
                //                    type: "grid",
                //                    gridOptions: {
                //                        type: "grid",
                //                        columnDefs: [
                //                            { field: 'aggregateId', width: 400 },
                //                            { field: 'note', width: '*' },
                //                            { field: 'createdBy', width: 240 },
                //                            { field: 'createdOn', width: 100 }
                //                        ]
                //                    }
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.project.operation.scheduledFiles', {
                //    url: '/scheduled/:parentId',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list-sm.html',
                //    controller: 'DynamicActionController',
                //    data: {
                //        apiUrl: '/{ownerId}/{parentId}/file-descriptor/scheduled-files',
                //    },
                //    resolve: {
                //        data: ['$stateParams', ($stateParams: dgUtils.IDgStateParamsService): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/' + $stateParams.parentId + '/file-descriptor/scheduled-files'
                //                },
                //                listInit: {
                //                    type: "grid",
                //                    gridOptions: {
                //                        type: "grid",
                //                        columnDefs: [
                //                            { field: 'aggregateId', width: 400 },
                //                            { field: 'note', width: '*' },
                //                            { field: 'periodStartDate', width: 140 },
                //                            { field: 'createdOn', width: 100 }
                //                        ]
                //                    }
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.project.products', {
                //    url: '/products',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list-sm.html',
                //    controller: 'ProjectProductsController',
                //    data: {
                //        apiUrl: '/{ownerId}/file-descriptor/product-files',
                //    },
                //    resolve: {
                //        data: ['$transition$', ($transition$: any): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/file-descriptor/product-files?fileOwnerId=' + $transition$.params().aggregateId
                //                },
                //                listInit: {
                //                    type: 'badge'
                //                }
                //            };
                //        }]
                //    }
                //})
                //.state('app.project.tasks', {
                //    url: '/tasks',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list-sm.html',
                //    controller: 'DynamicActionController',
                //    resolve: {
                //        data: ['$transition$', ($transition$: any): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/user-task/project-task-list?project=' + $transition$.params().aggregateId
                //                },
                //                listInit: {
                //                    type: "grid",
                //                    excelDownloadEnabled: true,
                //                    gridOptions: {
                //                        type: "grid",
                //                        columnDefs: [
                //                            { field: 'aggregateId', width: '*' },
                //                            { field: 'assignedTo', width: 340 },
                //                            { field: 'dueDate', width: 100 },
                //                            { field: 'taskStatus', width: 100 },
                //                            { field: 'dueStatus', width: 140 }  
                //                        ]
                //                    }
                //                }
                //            }
                //        }]
                //    }
                //})
                //.state('app.myProjects', {
                //    url: 'my-projects',
                //    controller: 'DynamicActionController',
                //    templateUrl: '/digmo/src/components/metadata/dynamic-list.html',
                //    resolve: {
                //        data: [(): dgMetadata.DynamicActionControllerData => {
                //            return {
                //                actionLink: {
                //                    href: '/project/my-project-list'
                //                },
                //                listInit: {
                //                    type: "grid",
                //                    excelDownloadEnabled: true,
                //                    gridOptions: {
                //                        type: "grid",
                //                        columnDefs: [
                //                            { field: 'aggregateId', width: 240 },
                //                            { field: 'roles', width: 340 },
                //                            { field: 'projectName', width: '*', minWidth: 200 },
                //                            { field: 'startDate', width: 100 },
                //                            { field: 'endDate', width: 140 }
                //                        ]
                //                    }
                //                }
                //            }
                //        }]
                //    }
                //});
            }]);

}